import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button } from 'react-bootstrap';
import TransferList from "./transferlist";
import React, { useState } from 'react';
function TransferButton(props) {

    const [showTransferList, setShowTransferList] = useState(false);

    const toggleTransferList = () => {
        setShowTransferList(!showTransferList);
    };

    return (
        <div className={"float-end m-1 position-relative"} >
            <Button variant='light-primary' size='sm' onClick={toggleTransferList}>
                <FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} />
            </Button>
            <div className="position-relative" style={{ left: 50 }}>
                <TransferList showTransferList={showTransferList} toggleTransferList={toggleTransferList} token={props.token} call={props.call} type={props.type}></TransferList>
            </div>
        </div>
    );
}

export default TransferButton;